import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/s" {...props}><path d="M29.6 23.511L18.67 4.527a3.096 3.096 0 0 0-5.338 0L2.401 23.511a2.939 2.939 0 0 0 0 2.965A3.044 3.044 0 0 0 5.068 28H26.93a3.045 3.045 0 0 0 2.667-1.524 2.938 2.938 0 0 0 .002-2.965zM15 13a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0v-5zm1 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" fill="#6A5901" /></svg>);